/** 平台创建的排班-时刻表-值班司机 */
<template>
  <div id="schedulingPlatformTimeDriverForm">
    <div class="schedulingPlatformTimeDriverForm-head">
      <span>{{ getWeek(schedulingTime) }} {{ schedulingTime | filterTime("MM-DD") }} 值班车辆 </span>
      <span class="util-remark">当天的订单将按派单顺序，自动派出</span>
    </div>

    <el-table :data="dutyDriversData" border style="width: 100%">
      <el-table-column prop="sort" label="派单顺序">
      </el-table-column>
      <el-table-column prop="licenseNo" label="车辆号牌">
        <template slot-scope="{row}">
          <span 
            v-if="row.licenseNo"
            :style="getPlateStyle(row.licenseNo)"
          >{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
          <span v-if="row.vehicleSeat" style="margin-left: 4px;">{{ row.vehicleSeat }}座</span>
        </template>
      </el-table-column>
      <el-table-column prop="driverName" label="值班司机"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{$index,row}">
          <el-button type="text" @click="deleteFn($index,row)">删除</el-button>
          <el-tooltip content="下移" placement="top" v-if="$index!=dutyDriversData.length-1" class="move-arrow">
            <i class="iconfont icon-move-down" @click="moveFn($index, 'down')"></i>
          </el-tooltip>
          <el-tooltip content="上移" placement="top" v-if="$index !== 0" class="move-arrow">
            <i class="iconfont icon-move-up" @click="moveFn($index, 'up')"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!--如果日期为当天，或当前为查看页，或班次条数已经15条，则隐藏【添加车辆】-->
    <div class="add" @click="addFn" v-if="dutyDriversData.length < 100">
      <i class="el-icon-plus"></i>添加车辆
    </div>

    <schedulingVehicle @confirm="vehicleConfirm" :line="lineInfo" :multiple="lineInfo.schedulingType === 2" :lineOId="lineInfo.organizationId" :drivers.sync="dutyDriversData" :visible.sync="schedulingVehicleShow" />

  </div>
</template>

<script>
export default {
  name: "schedulingPlatformTimeDriverForm",
  components: {
    schedulingVehicle: () => import("./schedulingVehicle.vue"),
  },
  props: ['lineInfo', 'schedulingTime'],
  data() {
    return {
      schedulingVehicleShow: false,
      dutyDriversData: [],
    }
  },
  watch: {
    schedulingTime: {
      handler(val) {
        if (val) {
          this.getNewDutyDriversData();
          this.$forceUpdate();
        }
      },
      deep: true,
      immediate: true,
    }
  },
  created() {

  },
  mounted() { },
  methods: {
    /* 最新的值班车辆列表 */
    async getNewDutyDriversData() {
      let url = "/api/v1/manage/line/scheduling/line/vehicle/" + this.lineInfo.id;
      let data = await this.$axios.get(url, { schedulingTime: this.schedulingTime });
      if (data && data.code == 1 && data.data.length > 0) {
        this.dutyDriversData = data.data[0].vehicleInfo;
      } else {
        this.dutyDriversData = [];
      }
    },

    /* 添加车辆 */
    addFn() {
      this.schedulingVehicleShow = true;
    },


    async vehicleConfirm(result) {
      let vehicleJson = [];
      result.map((item, index) => {
        if (!item.sort) {
          item.sort = index + 1;
          vehicleJson.push({
            driverId: item.driverId,
            vehicleId: item.vehicleId,
            licenseNo: item.licenseNo
          });
        }
      })
      if(vehicleJson.length==0){
        return;
      }

      let url = "/api/v1/manage/line/scheduling/line/vehicle";
      let data = await this.$axios.post(url, { lineId: this.lineInfo.id, schedulingTime: this.schedulingTime, vehicleJson: JSON.stringify(vehicleJson) });
      if (data && data.code == 1) {
        this.$message.success('车辆已添加');
        this.getNewDutyDriversData();
      }
    },

    /* 删除车辆 */
    deleteFn(index, row) {
      this.$confirm(`确定删除吗？`, "提示").then(async () => {
        let url = "/api/v1/manage/line/scheduling/line/vehicle/" + row.lineVehicleId;
        let data = await this.$axios.delete(url);
        if (data && data.code == 1) {
          this.$message.success('车辆已删除');
          this.dutyDriversData.splice(index, 1);
        }
      })
    },

    // 上下移动
    async moveFn(index, type) {
      if (type == "down") {
        [this.dutyDriversData[index], this.dutyDriversData[index + 1]] = [this.dutyDriversData[index + 1], this.dutyDriversData[index]];
      } else if (type == "up") {
        [this.dutyDriversData[index - 1], this.dutyDriversData[index]] = [this.dutyDriversData[index], this.dutyDriversData[index - 1]];
      }

      let params = this.dutyDriversData.map((item, index) => {
        return {
          id: item.lineVehicleId,
          sort: index + 1
        }
      })

      let url = "/api/v1/manage/line/scheduling/line/vehicle/sort";
      let data = await this.$axios.post(url, { sort: JSON.stringify(params) });
      if (data && data.code == 1) {
        this.$message.success('操作成功');
        this.getNewDutyDriversData();
      } else {
        if (type == "down") {
          [this.dutyDriversData[index], this.dutyDriversData[index + 1]] = [this.dutyDriversData[index + 1], this.dutyDriversData[index]];
        } else if (type == "up") {
          [this.dutyDriversData[index - 1], this.dutyDriversData[index]] = [this.dutyDriversData[index], this.dutyDriversData[index - 1]];
        }
      }
    },

    /* 获取日期 */
    getWeek(timestamp) {
      let date = new Date(timestamp * 1000);
      var week;
      if (date.getDay() == 0) week = "周日";
      if (date.getDay() == 1) week = "周一";
      if (date.getDay() == 2) week = "周二";
      if (date.getDay() == 3) week = "周三";
      if (date.getDay() == 4) week = "周四";
      if (date.getDay() == 5) week = "周五";
      if (date.getDay() == 6) week = "周六";
      return week;
    },
  },
};
</script>

<style lang="less" scoped>
#schedulingPlatformTimeDriverForm {
  .schedulingPlatformTimeDriverForm-head {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      &:nth-child(1) {
        font-size: 20px;
        font-weight: bold;
      }
      &:nth-child(2) {
        color: #666;
      }
    }
  }

  .move-arrow {
    color: #2b77ff;
    margin-left: 15px;
    cursor: pointer;
    position: relative;
    top: 2px;
  }

  .add {
    margin-top: 12px;
    width: calc(100% - 2px);
    border: 1px #ebebeb dashed;
    line-height: 28px;
    text-align: center;
    cursor: pointer;

    &:hover {
      border-color: @color-primary;
      color: @color-primary;
    }
  }
}
</style>
